import React from 'react';

export default props => {
  return (
    <div className="section">
      <h3 className="sectiontitle">About this Mapper</h3>
      <br />
      <div className="sectionitem" style={{ maxWidth: '600px' }}>
        <p style={{ marginBottom: '15px' }}>
          Search for your ZIP code or zoom in on your town to find DPC practices
          near you. Click on an icon to see details about that practice. When
          contacting a practice ask them to estimate how much you can save on
          your medications, labs, and specialty visits.
        </p>
        <p style={{ marginBottom: '15px' }}>
          The map contains a listing of public addresses and website links to{' '}
          {props.numPracs || 'all known'} DPC practice locations in 48 states +
          DC. All practices must meet our{' '}
          <a href="https://www.dpcfrontier.com/defined">
            three-part definition of DPC
          </a>{' '}
          to appear in the map, although they may not always self-describe as
          DPC. Multiple types of DPC practices appear in the mapper—Pure (no
          insurance whatsoever), Hybrid (insurance is billed in addition to
          monthly fee), and On-Site (usually exclusively serving the employees
          of a large corporation). Note the color-coding legend above the
          mapper.
        </p>
      </div>
    </div>
  );
};
